import React from "react";

const ProductSkeleton = () => {
  return (
    <div className="products-section">
      {/* Breadcrumb Skeleton */}
      <div className="breadcrumb-container">
        <div className="breadcrumb">
          <div className="skeleton-text skeleton-breadcrumb"></div>
        </div>
        <div className="filter-buttons">
          <div className="skeleton-btn skeleton-filter-btn"></div>
          <div className="skeleton-btn skeleton-filter-btn"></div>
        </div>
      </div>

      {/* Products Grid Skeleton */}
      <div className="products-grid no-scrollbar">
        {Array.from({ length: 12 }).map((_, index) => (
          <div key={index} className="pos-product-card skeleton-product-card">
            <div className="pos-product-header">
              <div className="skeleton-tag skeleton-condition-tag"></div>
              <div className="skeleton-tag skeleton-stock-tag"></div>
            </div>

            <div className="pos-product-image">
              <div className="skeleton-image skeleton-product-image"></div>
            </div>
            
            <div className="skeleton-text skeleton-product-name"></div>
            
            <div className="product-footer">
              <div className="skeleton-text skeleton-price"></div>
              <div className="quantity-controls">
                <div className="skeleton-btn skeleton-quantity-btn"></div>
                <div className="skeleton-text skeleton-quantity"></div>
                <div className="skeleton-btn skeleton-quantity-btn"></div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <style jsx>{`
        .skeleton-text {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 4px;
          height: 1rem;
        }

        .skeleton-breadcrumb {
          width: 200px;
          height: 1.2rem;
        }

        .skeleton-btn {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 6px;
          height: 2rem;
          width: 100px;
        }

        .skeleton-filter-btn {
          width: 120px;
        }

        .skeleton-tag {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 12px;
          height: 1.5rem;
          width: 50px;
        }

        .skeleton-stock-tag {
          width: 40px;
        }

        .skeleton-image {
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: loading 1.5s infinite;
          border-radius: 8px;
        }

        .skeleton-product-image {
          width: 100%;
          height: 120px;
        }

        .skeleton-product-name {
          width: 90%;
          height: 1.2rem;
          margin: 0.5rem 0;
        }

        .skeleton-price {
          width: 80px;
          height: 1.2rem;
        }

        .skeleton-quantity {
          width: 20px;
          height: 1rem;
        }

        .skeleton-quantity-btn {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }

        .skeleton-product-card {
          background: #fff;
          border: 1px solid #e9ecef;
          border-radius: 12px;
          padding: 1rem;
          transition: all 0.3s ease;
        }

        .skeleton-product-card:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        }

        .products-grid {
          display: grid;
          grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
          gap: 1rem;
          padding: 1rem 0;
        }

        .product-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 2rem;
        }

        .pos-product-image {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 2rem;
        }

        .product-footer {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-top: 0.5rem;
        }

        .quantity-controls {
          display: flex;
          align-items: center;
          gap: 0.5rem;
        }

        .breadcrumb-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1rem;
        }

        .filter-buttons {
          display: flex;
          gap: 0.5rem;
        }

        @keyframes loading {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
          .products-grid {
            grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
          }
        }

        @media (max-width: 576px) {
          .products-grid {
            grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
          }
        }
      `}</style>
    </div>
  );
};

export default ProductSkeleton;
